import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../utils/auth';
import api from '../api/axios';

export default function RequireAdminRoute({ children }) {
  const [autorizado, setAutorizado] = useState(null);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setAutorizado(false);
      return;
    }

    api.get('/auth/admin-routes', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      if (res.data.rol === 'admin') {
        setAutorizado(true);
      } else {
        setAutorizado(false);
      }
    })
    .catch(() => {
      setAutorizado(false);
    });
  }, []);

  if (autorizado === null) return null; // Loader opcional
  if (!autorizado) return <Navigate to="/login" />;

  return children;
}
